import React from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { toCurrency } from '../_helpers/pdfHelpers'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const KilometerTable = ({ sumKmDriven, pricePerKm }) => {
  return (
    <>
      <Grid justify="end" style={{ padding: '0.5rem 1rem' }}>
        <Table width="35%" style={{ border: '2px solid #333' }} color="#000">
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol color="#000">
              <Text bold size="small" align="center">
                KM Rodado
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Preço p/ KM
              </Text>
            </TableCol>
            <TableCol color="#000" width="23%">
              <Text bold size="small" align="center">
                Total
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#000">
            <TableCol color="#000">
              <Text size="small" align="center" color="#000">
                {sumKmDriven}
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text size="small" align="center" color="#000">
                {toCurrency(pricePerKm)}
              </Text>
            </TableCol>
            <TableCol color="#000" style={{ backgroundColor: '#ffc000' }}>
              <Text size="small" align="center" color="#000">
                {toCurrency(sumKmDriven * pricePerKm)}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </Grid>
    </>
  )
}

export default KilometerTable
